import React from 'react';
import Lottie from 'react-lottie';

import { Grid, Typography } from '@material-ui/core';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';

import { appConfig } from '../../config/app';

interface LoaderProps {
  action?: string;
}

const Loader: React.FC<LoaderProps> = ({ action }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: appConfig?.IMAGES?.LOADING,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: 9999, overflow: 'hidden' }}
      open={true}
    >
      <Box
        position="fixed"
        height="100vh"
        width="100vw"
        display="flex"
        alignItems="center"
        bgcolor={appConfig?.LOADER?.BACKGROUND_COLOR}
        zIndex="9999"
        overflow="hidden"
      >
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item>
            <Box position="relative">
              <Lottie height="20%" width="20%" options={defaultOptions} />
              <Box mt={2}>
                <Typography
                  variant="h6"
                  color={appConfig?.LOADER?.ACTION_COLOR as any}
                  align="center"
                >
                  {action}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Backdrop>
  );
};

export default Loader;
